import * as React from 'react'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'

interface Props {
  name: string
  tagText?: string
}

const ArchivedItem = ({ tagText, children, name }: React.PropsWithChildren<Props>) => {
  return (
    <Box alignItems="center" flexDirection="row" justifyContent="spaceBetween">
      <Text.Normal size="300" weight="medium" color="grey1000">
        {name}
      </Text.Normal>
      <Box flexDirection="row">
        {!!tagText && (
          <Box justifyContent="center" paddingRight="s16">
            <Tag type="grey">{tagText}</Tag>
          </Box>
        )}
        {children}
      </Box>
    </Box>
  )
}

export default ArchivedItem
